import * as React from 'react';
import type { SVGProps } from 'react';

const SvgLocationIconBlack = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={27} fill="none" {...props}>
    <path
      fill="#000000"
      d="M10 .622a10.012 10.012 0 0 0-10 10 9.9 9.9 0 0 0 2.015 6s.272.359.317.41L10 26.077l7.672-9.048c.04-.048.313-.406.313-.406l.001-.003A9.896 9.896 0 0 0 20 10.622a10.012 10.012 0 0 0-10-10Zm0 13.636a3.636 3.636 0 1 1 0-7.272 3.636 3.636 0 0 1 0 7.272Z"
    />
  </svg>
);
export default SvgLocationIconBlack;
